import cloneDeep from 'clone-deep'
import type { InputType } from 'config'
import { useEffect, useState } from 'react'
import { Modal } from 'stories/components'
import { InputConvert, InputValidate } from 'utils'
import { RenderInput } from 'utils/RenderInput'

import type { ILoanContact } from './types'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    name: {
      inputType: 'text',
      title: 'Name',
      required: true,
    },
    title: {
      inputType: 'text',
      title: 'Title',
      required: true,
    },
    email: {
      inputType: 'text',
      type: 'email',
      title: 'Email',
      required: true,
    },
    address: {
      inputType: 'map',
      title: 'Address',
      required: true,
    },
    phone: {
      inputType: 'text',
      type: 'phone',
      title: 'Phone',
      required: true,
    },
  }
}

export const AddContact = ({
  index,
  item,
  onClose,
  onUpdate,
}: {
  index: number
  item: ILoanContact | null
  onClose: Function
  onUpdate: Function
}) => {
  const [loading, setLoading] = useState(false)
  const [inputs, setInputs] = useState(defaultInputs())

  useEffect(() => {
    if (item) {
      const newInputs = cloneDeep(inputs)
      Object.keys(inputs).forEach((key) => {
        newInputs[key].value = (item as any)[key]
      })
      setInputs(newInputs)
    }
  }, [])

  const onChange = (key: string, value: string) => {
    let newInputs = cloneDeep(inputs)
    value = InputConvert(newInputs[key], value)
    newInputs[key].error = InputValidate({ ...newInputs[key], value })
    newInputs[key].value = value
    setInputs(newInputs)
  }

  const onSubmit = async () => {
    let hasError = false

    let newInputs = cloneDeep(inputs)
    const data: Record<string, any> = {}
    for (const key in inputs) {
      newInputs[key].error = InputValidate(newInputs[key])
      data[key] = newInputs[key].value
      if (newInputs[key].error) hasError = true
    }
    setInputs(newInputs)
    if (hasError) return
    setLoading(true)
    onUpdate(data)
  }

  return (
    <Modal
      title={item ? `Update Contact - No.${index + 1}` : 'Add Contact'}
      titleOkay="Submit"
      loading={loading}
      onClose={() => onClose()}
      onOk={onSubmit}
      childLevel={2}
      isOpen
    >
      <div className="text-gray-900">
        <div className="w-144 grid gap-4 md:grid-cols-2 grid-cols-1 mb-3 mt-2">
          {Object.keys(inputs).map((key, index) => {
            let input = inputs[key]
            return (
              <div className={`input md:col-span-${input.span || 1}`} key={index}>
                <RenderInput input={input} Key={key} onChange={onChange} />
              </div>
            )
          })}
        </div>
      </div>
    </Modal>
  )
}
